jQuery(document).ready(function ($) {

    isSmallMobile = {
        any: function () {
            return $(window).width() < 767;
        }
    };

    // Group Header 1 Slider JS
    var header_slider = new Swiper('.headerScroller .swiper-container', {
        speed: 300,
        slidesPerGroup: 1,
        slidesPerView: 8,
        centerInsufficientSlides: true,
        preloadImages: false,
        autoplay: {
            delay: 2500
        },
        loop: true,
        navigation: {
            nextEl: '.headerScroller .swiper-button-next.header',
            prevEl: '.headerScroller .swiper-button-prev.header'
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 3,
            },
            // when window width is >= 767px
            767: {
                slidesPerView: 4,
            },
            // when window width is >= 1024px
            1024: {
                slidesPerView: 6,
            },
        }
    });
    // Mobile Footer Menus
    if ($(window).width() <= 767) {
        // Changing widgettitle from span to button for accessibility
        $(".footerRow .linkWrapper__widgets li.widget .widgettitle").replaceWith(function () {
            return "<button class='widgettitle' role='heading' aria-level='3'>" + this.innerHTML + "</button>";
        });

        $('.footerRow .linkWrapper__widgets .widget').on('click', function () {
            $(this).toggleClass('active').siblings().removeClass('active');
            $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
        });
    }

    // Place Homepage only Javascript inside of IF statement
    if (document.body.classList.contains('home')) {

        // Reviews JS
        var reviews = new Swiper('.reviewsRow .swiper-container', {
            speed: 300,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 15,
            watchOverflow: true,
            lazy: {
                enabled: true,
            },
            navigation: {
                nextEl: '.reviewsRow .swiper-button-next.reviews',
                prevEl: '.reviewsRow .swiper-button-prev.reviews'
            },
        });
    }

});